import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import '@fontsource/nunito' // Defaults to weight 400
import '@fontsource/nunito/400.css' // Specify weight
import '@fontsource/nunito/400-italic.css' // Specify weight and style
import '@fontsource/nunito/300.css'
import '@fontsource/nunito/700.css'
import router from './routes/AppRoutes'
import { OCConnect } from '@opencampus/ocid-connect-js'

const opts = {
  redirectUri: process.env.REACT_APP_OC_REDIRECT_URI,
}

function App() {
  const isSandboxMode = process.env.REACT_APP_OC_SANBOX_MODE === 'true'

  return (
    <OCConnect opts={opts} sandboxMode={isSandboxMode}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </OCConnect>
  )
}

export default App
